<template>
    <ag-loading v-if="loading" class="ag-loading" />
    <div class="create-event">
        <div v-if=!loading>
            <div class="d-flex justify-content-between align-items-center create-event-header">
                <div class="ml-4">
                    <h4>
                        <template v-if="showDropdown">
                            <div>
                                <h3 class="label">
                                    {{ $t("createEventsSeverity") }}
                                </h3>
                                <div class="dropdown-container">
                                    <h5 class="label">
                                        {{ $t("eventtype") }}:
                                    </h5>
                                    <select v-model="elementCategory" class="form-control eventTypeSelect">
                                        <option v-for="option in eventTypeOptions" :key="option.value" :value="option.value"
                                            :selected="option.selected">
                                            {{ option.text }}</option>
                                    </select>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            {{ $t("createEventsSeverity") }} | {{ selectedRow.eventType ?? selectedRow.eventTypeName ?? this.elementCategory }}
                        </template>
                    </h4>
                </div>
                <div class="mr-5 mb-2 pb-2">
                    <h5 v-if="!isTemplate">{{ $t("group") }}:
                        <span class="italic">
                            {{ this.computerGroup.groupName ?? selectedRow.computerGroup ?? this.group.group }}
                        </span>
                    </h5>
                    <h5>{{ $t("rolePolicy") }}:
                        <span class="italic">
                            {{ this.template && this.template.Name ? this.template.Name : this.template }}
                        </span>
                    </h5>
                </div>
            </div>
            <div v-for="(rule, ruleIndex) in rules" :key="ruleIndex" class="rules">
                <div class="d-flex align-items-center">
                    <div class="form-group col-md-6">
                        <label style="margin-right: 15px;" for="rule-severity">{{ $t("logSeverityList") }}:</label>
                        <Dropdown filter  v-model="rule.severity" :options="severityOptions" optionLabel="value" appendTo="self"
                        autoFilterFocus="true"
                        optionValue="label" style="width: 25rem" />
                    </div>
                    <div class="form-group col-md-6">
                        <label style="margin-right: 10px;" >{{ $t("Alert") }}: </label>
                        <input type="checkbox" v-model="rule.alertable" />

                    </div>
                </div>
                <div v-for="(condition, conditionIndex) in rule.conditions" :key="conditionIndex"
                    class="d-flex align-items-center ">
                    <span class="and-text col-md-1"
                        :style="{ 'opacity': conditionIndex === 0 ? 0 : 1, 'margin-bottom': conditionIndex > 0 ? '27px' : '' }">{{
                            $t("and")
                        }}</span>

                    <div class="form-group col-md-4">
                        <label v-if="conditionIndex === 0" for="property">{{ $t("property") }}:</label>
                        <Dropdown filter  v-model="condition.property" :options="apiProperties" optionLabel="value" appendTo="self"
                        autoFilterFocus="true"
                        optionValue="value" style="width: 25rem" panelClass="DrowDownFontFix" @change="updateLevelsBasedOnProperty(ruleIndex, conditionIndex)">
                    </Dropdown>
                    </div>
                    <div class="form-group col-md-1">
                        <label v-if="conditionIndex === 0" for="operator">{{ $t("operator") }}:</label>
                        <select v-model="condition.operator" class="form-control" style="width: 6rem">
                            <option v-for="operator in apiConditions" :key="operator.value" :value="operator.value">{{
                                operator.text }}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-4">
                        <label v-if="conditionIndex === 0" for="value">{{ $t("value") }}:</label>
                        <input v-model="condition.value" placeholder="empty" type="text" class="form-control"
                            style="width: 25rem" />
                    </div>
                    <div class="form-group col-md-1">
                        <label v-if="conditionIndex === 0" for="level">{{ $t("level") }}:</label>
                        <select v-model="condition.level" class="form-control" :disabled="condition.isLevelDisabled"
                            style="width: 7rem">
                            <option v-for="level in currentLevels[conditionIndex]" :key="level.value" :value="level.value">
                                {{ level.text }}
                            </option>
                        </select>
                    </div>
                    <div class="d-flex align-items-center justify-content-end col-md-1">
                        <i @click="deleteCondition(ruleIndex, conditionIndex)"
                            :style="{ 'margin-bottom': conditionIndex > 0 ? '27px' : '' }"
                            class="btn ag-icon ag-icon_delete delete-icon" :title="$t('deleteCondition')"></i>
                    </div>
                </div>
                <div class="add-condition-container">
                    <span class="add-condition-btn" @click="addCondition(ruleIndex)">
                        <i class="btn d-flex align-items-center">
                            <i class="ag-icon ag-icon_add_black icon"></i>
                            <span>{{ $t("addCondition") }}</span>
                        </i>
                    </span>
                </div>
                <!-- <hr /> -->
            </div>
            <!-- <div class="pl-4">
                <i @click="addRule" class="btn d-flex align-items-center">
                    <i class="ag-icon ag-icon_add_black icon"></i>
                    <span>Add Rule</span>
                </i>
            </div> -->
            <div class="d-flex justify-content-end align-items-center create-event-footer">
                <div>
                    <label for="apply-to" v-if="!showDropdown && admin">{{ $t("applyTo") }}:</label>
                    <div v-if="!showDropdown && admin" class="form-check form-check-inline ml-2">
                        <input type="radio" id="apply-to-role" class="form-check-input" value="role" v-model="applyTo" />
                        <label class="form-check-label" for="apply-to-role">{{ $t("rolePolicyAndGroup") }}</label>
                    </div>
                    <div v-if="!showDropdown && admin" class="form-check form-check-inline ml-2">
                        <input type="radio" id="apply-to-group" class="form-check-input" value="group" v-model="applyTo" />
                        <label class="form-check-label" for="apply-to-group">{{ $t("group") }}</label>
                    </div>
                    <button type="button" class="ag-button border-0 ag-button_secondary ag-button_radius ml-2"
                        @click="closePopup">{{ $t("cancel") }}</button>
                    <button type="button" class="ag-button border-0 ag-button_primary ag-button_radius ml-2 mr-4"
                        @click="saveChanges">{{ $t("save") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, Vue } from 'vue';
import { mapState, mapGetters } from "vuex";
import { useStore } from "@/store";
import AgLoading from "@/components/ag-loading/index.vue";
import axios from "axios";
import { notify } from "@kyvg/vue3-notification";
import api from "@/api/index";
import axiosApi from "@/store/axiosAgsc";
import { Roles, Rules } from "@/helpers/enums/Roles";
import Checkbox from 'primevue/checkbox';

const store = useStore();
const agmsUrl = process.env.VUE_APP_AGMS_URL;
// const group = store.getters.group;

let requestModel = {};
let groupString = localStorage.getItem("agms_group");
let group = JSON.parse(groupString);
let groupId = 0;
let templateString = localStorage.getItem("agms_template");
let template = JSON.parse(templateString);

let siteString = localStorage.getItem("agms_site");
let site = JSON.parse(siteString);

let response = '';

const memoryGuardEvent = "MemoryGuardEvent";
const registryLockEvent = "RegistryLockEvent";
const agentEvent = "AgentEvent";
const fileLockEvent = "FileLockEvent";
const processCheckEvent = "ProcessCheckEvent";
const codeLoadEvent = "CodeLoadEvent";
const fileExtensionEvent = "FileExtensionEvent";

const eventInspection = "eventInspection";
const policyReview = "policyReview";

export default {
    props: {
        clickedRule: Object,
        associatedConditions: Array,
    },
    data() {
        return {
            applyTo: "group",
            loading: true,
            rules: [
                {
                    severity: null,
                    conditions: [{ property: "", operator: "", value: null, level: null, isLevelDisabled: true, }],
                    alertable: false
                },
            ],
            apiConditions: [],
            apiProperties: [],
            apiLevels: [],
            apiPublisherLevels: [],
            currentLevels: [],
            template: {},
            groupRequestBody: {},
            templateRequestBody: {},
            group: null,
            elementCategory: null,
            elementCategories: null,
            selectedEventType: '',
            duplicate: false,
            update: {},
            newCondition: false,
            isTemplate: false,
            computerGroup: {},
            getComputer: false,
            isTemplateInitialized: false,
            selectedEventTypeOption: '',
            routeName: '',
            alertable: false,
            severityOptions: [
                { label: 0, value: 'Default' },
                { label: 1, value: 'Lowest (1)' },
                { label: 2, value: 'Low (2)' },
                { label: 3, value: 'Medium (3)' },
                { label: 4, value: 'High (4)' },
                { label: 5, value: 'Critical (5)' },
            ],
            isAdmin: true,
        };
    },

    computed: {
        admin() {
            return this.isAdmin;
        },
        selectedRow() {
            return store.state.general.selectedExpandedRow;
        },

        showDropdown() {
            return (this.routeName == eventInspection || this.routeName == policyReview) ? false : true;
        },

        eventTypeOptions() {
            if (this.elementCategories && (this.elementCategory)) {
                const options = this.elementCategories.map(category => ({
                    value: category.value,
                    text: category.text,
                }));

                const selectedOption = options.find(option => option.value === (this.elementCategory));
                if (selectedOption) {
                    selectedOption.selected = true;
                } else if (options.length > 0) {
                    options[0].selected = true;
                }

                const eventTypeProperties = this.apiProperties.filter(property => property.text.startsWith(this.elementCategory));
                this.rules.forEach(rule => {
                    rule.conditions.forEach(condition => {
                        const selectedProperty = eventTypeProperties.find(property => property.value === condition.property);
                        condition.property = selectedProperty ? selectedProperty.value : '';
                    });
                });

                return options;
            } else {
                const options = this.elementCategories.map(category => ({
                    value: category.value,
                    text: category.text,
                }));
                return options;
            }
        },

        ...mapState({
            agmsCompany: (state) => state.auth.company,
            agmsGroup: (state) => state.auth.agmsGroup,
            agmsSite: (state) => state.auth.agmsSite,
            agmsTemplate: (state) => state.auth.agmsTemplate,
        }),
        ...mapGetters(["loggedInUser"]),
    },

    components: {
        AgLoading,
    },

    async created() {
        
        this.routeName = this.$route.name;
        if ((this.routeName == policyReview || this.routeName == eventInspection) && (this.selectedRow.eventType || this.selectedRow.eventTypeName)) {
            await axiosApi
                .get(
                    `Computer/GetComputerDetail?computerGuid=${this.selectedRow.computerGuid}&eventType=${this.selectedRow.eventType ?? this.selectedRow.eventTypeName}&groupId=${this.selectedRow.groupGuid  ?? this.selectedRow.GroupGuid}`
                )
                .then((res) => {
                    this.computerGroup = res.data.entityData.companySiteGroupInfo;
                    this.getComputer = true;
                    this.fetchApiData();
                    this.updateSeverity();
                    this.routeName == eventInspection ? this.setDefaultConditions() : this.setPolicyReviewDefaultConditions();
                    this.updateIsLevelDisabled();
                    this.isTemplateInitialized = true;
                });
        }
        this.group = JSON.parse(localStorage.getItem("agms_group")) || {};
        this.isAdmin = [
                Roles.AGMSAdmin,
                Roles.PartnerAdmin,
                Roles.CompanyAdmin
            ].includes(localStorage.realRole);
        this.updateIsLevelDisabled();
    },

    methods: {
        addCondition(ruleIndex) {
            this.rules[ruleIndex].conditions.push({ property: "", operator: "", value: null, level: null, isLevelDisabled: true });
            this.newCondition = true;
        },

        addRule() {
            this.rules.push({ severity: "", conditions: [{ property: "", operator: "", value: null, level: null }] });
        },

        closePopup() {
            this.$emit("close-popup");
        },

        deleteCondition(ruleIndex, conditionIndex) {
            this.rules[ruleIndex].conditions.splice(conditionIndex, 1);
        },

        deleteRule(ruleIndex) {
            this.rules.splice(ruleIndex, 1);
        },

        async duplicateRule(rule, template, type, requestBody) {
            this.isTemplate = template;
            this.update = rule;
            if (rule) {
                this.isTemplateInitialized = true;
            }

            if (this.isTemplate) {
                this.templateId = type;
                this.templateRequestBody = requestBody;
                await this.getTemplateList();
            } else if (!this.isTemplate) {
                this.group = type;
                this.groupRequestBody = requestBody;
                await this.getPolicyList();
            }

            const conditionsArray = Array.isArray(rule?.conditions) ? rule.conditions : [];
            const elementCategory = conditionsArray.length > 0 ? conditionsArray[0].elementCategory : '';
            this.duplicate = true;
            this.elementCategory = elementCategory;
            this.rules = [{
                severity: rule?.severity,
                alertable: rule?.alertable,
                conditions: conditionsArray.map(condition => {
                    const propertyWithoutCategory = condition.elementName.replace(`${elementCategory}.`, '');

                    return {
                        property: propertyWithoutCategory || '',
                        operator: condition.condition || '',
                        value: condition.value || null,
                        level: condition.level || null,
                    };
                }),
            }];
            this.$nextTick(() => {
                this.rules.forEach((rule, ruleIndex) => {
                    rule.conditions.forEach((condition, conditionIndex) => {
                        this.updateLevelsBasedOnProperty(ruleIndex, conditionIndex);
                    });
                });
                this.updateIsLevelDisabled();
            });
        },

        async fetchApiData() {
            try {
                if ((this.selectedRow.eventType || this.selectedRow.eventTypeName) && this.computerGroup.groupGuid) {
                    const response = await axiosApi.get(`agms/SeverityEvents/GetSeverityEventListByGroupGuid?groupGuid=${this.selectedRow.groupGuid  ?? this.selectedRow.GroupGuid}`);

                    const eventType = (this.selectedRow.eventType ?? this.selectedRow.eventTypeName) || this.elementCategory || this.selectedEventType;
                    const groupViewModel = response.data.entityData;
                    this.apiConditions = groupViewModel.conditions || [];
                    this.apiProperties = (groupViewModel.elementNames || []).filter(property => property.text.startsWith(eventType)) || [];
                    this.apiLevels = groupViewModel.positions || [];
                    this.apiPublisherLevels = groupViewModel.publisherPositions || [];
                    this.groupRequestBody = groupViewModel.groupPolicyViewModel;
                    this.templateRequestBody = groupViewModel.templatePolicyViewModel;
                    this.elementCategories = groupViewModel.elementCategories;
                    this.templateId = groupViewModel.templateId;
                    this.template = groupViewModel.templateType;
                    groupId = groupViewModel.groupPolicyViewModel.groupID;
              
                    if (this.selectedEventType) {
                        this.rules = [
                            {
                                severity: '',
                                conditions: [{ property: "", operator: "", value: null, level: null, isLevelDisabled: true }],
                                alertable: false
                            },
                        ];
                        
                    }
                    this.rules[0].alertable= false;
                    setTimeout(() => {
                        this.loading = false;
                    }, 350);
                }
            } catch (error) {
                console.error('Error:', error);
                this.loading = false;
                notify({
                    title: this.$t("error"),
                    type: "error",
                    text: error,
                    duration: 8000,
                });
            }
        },

        prepareConditions(conditions) {
            return conditions.map((condition, conditionIndex) => ({
                // ID: lastConditionId++,
                // RuleId: ruleIndex,
                ElementCategory: this.selectedRow?.eventType || this.elementCategory || this.selectedEventType || this.selectedRow.eventTypeName,
                ElementName: condition.property,
                Condition: condition.operator,
                Value: condition.value,
                Level: condition.level,
            }));
        },

        prepareRules(EventSeverity,GroupID) {
            const rule = this.rules.map((rule, ruleIndex) => ({
                ID: this.elementCategory && this.isTemplateInitialized ? this.update.id : 0,
                SeverityEventId: EventSeverity.id,
                Severity: rule.severity,
                Alertable:rule.alertable,
                Conditions: this.prepareConditions(rule.conditions),
                GroupId: GroupID,
            }))[0];
            return rule;
        },
       
        async getPolicyList() {
            try {
                
                const response = await axiosApi.get(`agms/SeverityEvents/GetSeverityEventList?mainid=${group.mainid}`);
                const eventType = this.selectedRow?.eventType || this.elementCategory || this.selectedEventType;
                const groupViewModel = response.data.entityData;
                this.apiConditions = groupViewModel.conditions || [];
                this.apiProperties = (groupViewModel.elementNames || []).filter(property => property.text.startsWith(eventType)) || [];
                this.apiLevels = groupViewModel.positions || [];
                this.apiPublisherLevels = groupViewModel.publisherPositions || [];
                this.groupRequestBody = groupViewModel.groupPolicyViewModel;
                this.elementCategories = groupViewModel.elementCategories;
                this.templateId = groupViewModel.templateId;
                this.template = groupViewModel.templateType;
                groupId = groupViewModel.groupPolicyViewModel.groupID;
                
                if (this.selectedEventType) {
                    this.rules = [
                        {
                            severity: '',
                            conditions: [{ property: "", operator: "", value: null, level: null, isLevelDisabled: true }],
                            alertable: false
                        },
                    ];
                }
                this.rules[0].alertable= false;
                setTimeout(() => {
                    this.loading = false;
                }, 350);
            } catch (error) {
                console.error('Error:', error);
                this.loading = false;
                notify({
                    title: this.$t("error"),
                    type: "error",
                    text: error,
                    duration: 8000,
                });
            }
        },

        async getTemplateList() {
            try {
                let url = `agms/TemplatePolicy/GetTemplateSeverityEventList?templateId=${this.templateId}`;
                let res = await axiosApi.get(url);
                const eventType = this.selectedRow?.eventType || this.elementCategory || this.selectedEventType;
                const groupViewModel = res.data.entityData;
                this.apiConditions = groupViewModel.conditions || [];
                this.apiProperties = (groupViewModel.elementNames || []).filter(property => property.text.startsWith(eventType)) || [];
                this.apiLevels = groupViewModel.positions || [];
                this.apiPublisherLevels = groupViewModel.publisherPositions || [];
                this.templateRequestBody = groupViewModel.templatePolicyViewModel;
                this.elementCategories = groupViewModel.elementCategories;
                this.templateId = groupViewModel.templateId;
                this.template = groupViewModel.templateType;
                if (this.selectedEventType) {
                    this.rules = [
                        {
                            severity: '',
                            conditions: [{ property: "", operator: "", value: "", level: null, isLevelDisabled: true }],
                        },
                    ];
                }
               
                setTimeout(() => {
                    this.loading = false;
                }, 350);
            } catch (error) {
                console.error('Error:', error);
                this.loading = false;
                notify({
                    title: this.$t("error"),
                    type: "error",
                    text: error,
                    duration: 8000,
                });
            }
        },

        saveChanges() {
            if (this.rules.length === 0 || this.rules.every(rule => rule.conditions.length === 0)) {
                notify({
                    title: this.$t("warning"),
                    text: this.$t("ignoreEventsRules"),
                    type: "warning",
                    duration: 4000,
                });
                return;
            }
            if (this.rules.some(rule => rule.conditions.length === 0)) {
                notify({
                    title: this.$t("warning"),
                    text: this.$t("ignoreEventsConditionsCheck"),
                    type: "warning",
                    duration: 4000,
                });
                return;
            }
            if (this.rules.some((rule, ruleIndex) => {
                const conditions = rule.conditions;
                return conditions.some(cond => !cond.property || !cond.operator);
            })) {
                notify({
                    title: this.$t("warning"),
                    text: this.$t("eventSeverityRequired"),
                    type: "warning",
                    duration: 4000,
                });
                return;
            }
            if (this.showDropdown && !this.elementCategory) {
                notify({
                    title: this.$t("warning"),
                    text: this.$t("severityEventsEventType"),
                    type: "warning",
                    duration: 4000,
                });
                return;
            }
            this.sendRequest();
        },

        sendRequest() {
            this.loading = true;
            if (!this.routeName != eventInspection && !this.routeName != policyReview && !this.selectedRow.eventType && !this.selectedRow.eventTypeName)
                this.applyTo = this.isTemplate ? 'role' : 'group';
            
            const isGroup = this.applyTo === 'group';
            const isEventInspection = (this.routeName === eventInspection || this.routeName == policyReview);
            const isTemplateSeverityEvent = this.routeName === 'templateSeverityEvents';

            const requestBody = (isEventInspection && !this.isAdmin) ? this.groupRequestBody.severityEvents :
                (isGroup ? this.groupRequestBody.severityEvents : this.templateRequestBody.severityEvents);
            const routePrefix = isGroup ? 'agms/SeverityEvents' : 'agms/TemplatePolicy';
            const newRule = this.prepareRules(requestBody,groupId);
            const requestModel = {
                ID: this.duplicate ? 0 : newRule.ID,
                SeverityEventId: newRule.SeverityEventId,
                Severity: newRule.Severity,
                Alertable:newRule.Alertable,
                Conditions: newRule.Conditions,
                GroupId: groupId,
            };
            if ((this.isTemplate || this.applyTo == 'role') && (isEventInspection || isTemplateSeverityEvent) && this.isAdmin) {
                requestModel.TemplateId = this.templateId;
            }

            axiosApi.post(`${routePrefix}/CreateOrUpdateSeverityEventFilterRule`, requestModel)
                .then(response => {
                    if (response.data.statusCode === 200 && response.data.isSuccess) {
                        this.loading = false;
                        this.closePopup();
                        if (this.selectedEventType || this.elementCategory) {
                            this.$emit('event-severity-updated');
                        }
                        notify({
                            title: this.$t('eventSeveritySuccess'),
                            type: 'success',
                            duration: 4000,
                        });
                    } else {
                        notify({
                            title: this.$t("error"),
                            type: "error",
                            text: response.data.message,
                            duration: 8000,
                        });
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    this.loading = false;
                    notify({
                        title: this.$t('error'),
                        type: 'error',
                        text: error,
                        duration: 8000,
                    });
                });
        },

        setPolicyReviewDefaultConditions() {
            const eventType = this.selectedRow.eventTypeName;
            const eventDetails = this.selectedRow.EventDetails;
            const defaultConditions = [];
            switch (eventType) {
                case registryLockEvent:
                    defaultConditions.push(
                        { property: "registryKey.path", operator: "EQ", value: eventDetails.RegistryKey.Path ? eventDetails.RegistryKey.Path : null, level: null },
                        { property: "registryKey.operation", operator: "EQ", value: eventDetails.RegistryKey.Operation ? eventDetails.RegistryKey.Operation : null, level: null },
                        { property: "process.file.path", operator: "EQ", value: eventDetails.Process.File.Path ? eventDetails.Process.File.Path : null, level: null }
                    );
                    break;
                case fileLockEvent:
                    defaultConditions.push(
                        { property: "process.file.path", operator: "EQ", value: eventDetails.Process.File.Path ? eventDetails.Process.File.Path : null, level: null },
                        { property: "file.path", operator: "EQ", value: eventDetails.File.Path ? eventDetails.File.Path : null, level: null },
                        { property: "operationType", operator: "EQ", value: eventDetails.OperationType ? eventDetails.OperationType : null, level: null }
                    );
                    break;
                case memoryGuardEvent:
                    defaultConditions.push(
                        { property: "processActor.file.path", operator: "EQ", value: eventDetails.ProcessActor.File.Path ? eventDetails.ProcessActor.File.Path : null, level: null },
                        { property: "operation", operator: "EQ", value: eventDetails.Operation ? eventDetails.Operation : null, level: null },
                        { property: "processTarget.file.path", operator: "EQ", value: eventDetails.ProcessTarget.File.Path ? eventDetails.ProcessTarget.File.Path : null, level: null }
                    );
                    break;
                case codeLoadEvent:
                    defaultConditions.push(
                        { property: "process.file.path", operator: "EQ", value: eventDetails.Process.File.Path ? eventDetails.Process.File.Path : null, level: null },
                        { property: "file.path", operator: "EQ", value: eventDetails.File.Path ? eventDetails.File.Path : null, level: null }
                    );
                    break;
                case agentEvent:
                    defaultConditions.push(
                        { property: "source", operator: "EQ", value: eventDetails.Source ? eventDetails.Source : null, level: null },
                        { property: "resultContext", operator: "EQ", value: eventDetails.ResultContext ? eventDetails.ResultContext : null, level: null }
                    );
                    break;
                case processCheckEvent:
                    defaultConditions.push(
                        { property: "process.file.path", operator: "EQ", value: eventDetails.Process.File.Path ? eventDetails.Process.File.Path : null, level: null }
                    );
                    break;
                case fileExtensionEvent:
                    defaultConditions.push(
                        { property: "process.file.path", operator: "EQ", value: eventDetails.Process.File.Path ? eventDetails.Process.File.Path : null, level: null },
                        { property: "file.path", operator: "EQ", value: eventDetails.File.Path ? eventDetails.File.Path : null, level: null },
                        { property: "operationType", operator: "EQ", value: eventDetails.OperationType ? eventDetails.OperationType : null, level: null }
                    );
                    break;
                default:
                    break;
            }

            this.rules[0].conditions = JSON.parse(JSON.stringify(defaultConditions));
        },

        setDefaultConditions() {
            const eventType = this.selectedRow.eventType;
            const defaultConditions = [];

            switch (eventType) {
                case registryLockEvent:
                    {
                        const parts = this.selectedRow.target.split(' ');
                        let path = parts.slice(0, -1).join(' ');
                        let operation = parts[parts.length - 1];

                        defaultConditions.push(
                            { property: "registryKey.path", operator: "EQ", value: path ? path : null, level: null },
                            { property: "registryKey.operation", operator: "EQ", value: operation ? operation : null, level: null },
                            { property: "process.file.path", operator: "EQ", value: this.selectedRow.processPath ? this.selectedRow.processPath : null, level: null }
                        );
                    }
                    break;
                case fileLockEvent:
                    defaultConditions.push(
                        { property: "process.file.path", operator: "EQ", value: this.selectedRow.processPath ? this.selectedRow.processPath : null, level: null },
                        { property: "file.path", operator: "EQ", value: this.selectedRow.targetPath ? this.selectedRow.targetPath : null, level: null },
                        { property: "operationType", operator: "EQ", value: this.selectedRow.operationType ? this.selectedRow.operationType  : null, level: null }
                    );
                    break;
                case memoryGuardEvent:
                    defaultConditions.push(
                        { property: "processActor.file.path", operator: "EQ", value: this.selectedRow.actorPath ? this.selectedRow.actorPath + this.selectedRow.actor : null, level: null },
                        { property: "operation", operator: "EQ", value: this.selectedRow.operation ? this.selectedRow.operation : null, level: null },
                        { property: "processTarget.file.path", operator: "EQ", value: this.selectedRow.targetPath ? this.selectedRow.targetPath + this.selectedRow.target: null, level: null }
                    );
                    break;
                case codeLoadEvent:
                    defaultConditions.push(
                        { property: "process.file.path", operator: "EQ", value: this.selectedRow.processPath ? this.selectedRow.processPath : null, level: null },
                        { property: "file.path", operator: "EQ", value: this.selectedRow.targetPath ? this.selectedRow.targetPath + this.selectedRow.target : null, level: null }
                    );
                    break;
                case agentEvent:
                    defaultConditions.push(
                        { property: "source", operator: "EQ", value: this.selectedRow.source ? this.selectedRow.source : null, level: null },
                        { property: "resultContext", operator: "EQ", value: this.selectedRow.target ? this.selectedRow.target : null, level: null }
                    );
                    break;
                case processCheckEvent:
                    defaultConditions.push(
                        { property: "process.file.path", operator: "EQ", value: this.selectedRow.processPath ? this.selectedRow.processPath : null, level: null }
                    );
                    break;
                case fileExtensionEvent:
                    defaultConditions.push(
                        { property: "process.file.path", operator: "EQ", value: this.selectedRow.actorPath ? this.selectedRow.actorPath + this.selectedRow.actor : null, level: null },
                        { property: "file.path", operator: "EQ", value: this.selectedRow.targetPath ? this.selectedRow.targetPath + this.selectedRow.target : null, level: null },
                        { property: "operationType", operator: "EQ", value: this.selectedRow.operationType ? this.selectedRow.operationType  : null, level: null }
                    );
                    break;
                default:
                    break;
            }

            this.rules[0].conditions = JSON.parse(JSON.stringify(defaultConditions));
        },

        async setRuleAndConditions(rule, template, type, requestBody) {
            this.isTemplate = template;
            this.update = rule;
            if (rule) {
                this.isTemplateInitialized = true;
            }
            const conditionsArray = Array.isArray(rule?.conditions) ? rule.conditions : [];
            const elementCategory = conditionsArray.length > 0 ? conditionsArray[0].elementCategory : '';
            this.elementCategory = elementCategory;

            if (this.isTemplate && rule) {
                this.templateId = type;
                this.templateRequestBody = requestBody;
                await this.getTemplateList();
            } else if (!this.isTemplate && rule) {
                this.group = type;
                this.groupRequestBody = requestBody;
                await this.getPolicyList();
            }

            this.rules = [{
                severity: rule?.severity,
                alertable: rule?.alertable,
                conditions: conditionsArray.map(condition => {
                    const propertyWithoutCategory = condition.elementName.replace(`${elementCategory}.`, '');

                    return {
                        property: propertyWithoutCategory || '',
                        operator: condition.condition || '',
                        value: condition.value || null,
                        level: condition.level || null,
                    };
                }),
            }];
            this.$nextTick(() => {
                this.rules.forEach((rule, ruleIndex) => {
                    rule.conditions.forEach((condition, conditionIndex) => {
                        this.updateLevelsBasedOnProperty(ruleIndex, conditionIndex);
                    });
                });
                this.updateIsLevelDisabled();
            });
        },

        updateIsLevelDisabled() {
            this.rules.forEach((rule) => {
                rule.conditions.forEach((condition) => {
                    const item = condition.property;
                    condition.isLevelDisabled = !item.includes('ancestors.ancestor') && !item.includes('publishers.publisher');
                });
            });
        },

        updateLevelsBasedOnProperty(ruleIndex, conditionIndex) {
            const item = this.rules[ruleIndex].conditions[conditionIndex].property;
            const condition = this.rules[ruleIndex].conditions[conditionIndex];
            if (!this.currentLevels[conditionIndex]) {
                this.currentLevels[conditionIndex] = [];
            }
            if (!this.selectedEventType && this.update && Object.keys(this.update).length > 0 && !this.newCondition) {
                if (item.includes('ancestors.ancestor')) {
                    const formattedLevels = [
                        { text: 'Any', value: -1 },
                        { text: 'Process', value: 0 },
                        { text: 'Parent', value: 1 },
                        { text: 'GrandParent', value: 2 }
                    ];
                    this.currentLevels[conditionIndex] = this.apiLevels;
                    if (this.update.conditions[conditionIndex].level !== null) {
                        condition.level = formattedLevels[this.update.conditions[conditionIndex].level + 1].value;
                    } else {
                        condition.level = this.apiLevels[1].value;
                    }
                    condition.isLevelDisabled = false;
                } else if (item.includes('publishers.publisher')) {
                    const formattedLevels = [
                        { text: 'Any Certificates', value: -1 },
                        { text: 'Primary Certificate', value: 0 },
                        { text: 'Secondary Certificate', value: 1 },
                        { text: 'Third Certificate', value: 2 }
                    ];
                    this.currentLevels[conditionIndex] = this.apiPublisherLevels;
                    if (this.update.conditions[conditionIndex].level !== null) {
                        condition.level = formattedLevels[this.update.conditions[conditionIndex].level + 1].value;
                    } else {
                        condition.level = this.apiPublisherLevels[1].value;
                    }
                    condition.isLevelDisabled = false;
                } else {
                    condition.level = null;
                    condition.isLevelDisabled = true;
                }
            } else {
                if (item.includes('ancestors.ancestor')) {
                    this.currentLevels[conditionIndex] = this.apiLevels;
                    condition.level = this.apiLevels.length > 0 ? this.apiLevels[2].value : null;
                    condition.isLevelDisabled = false;
                } else if (item.includes('publishers.publisher')) {
                    this.currentLevels[conditionIndex] = this.apiPublisherLevels;
                    condition.level = this.apiPublisherLevels.length > 0 ? this.apiPublisherLevels[1].value : null;
                    condition.isLevelDisabled = false;
                } else {
                    condition.level = null;
                    condition.isLevelDisabled = true;
                }
            }
        },
        updateSeverity() {
            const severity = this.selectedRow.severity;
            switch (severity) {
                case 'Default':
                    this.rules[0].severity = 0;
                    break;
                case 'Lowest':
                    this.rules[0].severity = 1;
                    break;
                case 'Low':
                    this.rules[0].severity = 2;
                    break;
                case 'Medium':
                    this.rules[0].severity = 3;
                    break;
                case 'High':
                    this.rules[0].severity = 4;
                    break;
                case 'Critical':
                    this.rules[0].severity = 5;
                    break;
                default:
                    break;
            }
        },
    },


    watch: {
        elementCategory(newElementCategory, oldElementCategory) {
            if (newElementCategory !== oldElementCategory) {
                this.loading = true;
                this.isTemplate ? this.getTemplateList() : this.getPolicyList();
            }
        },

        selectedEventType: {
            handler() {
                if (this.isTemplateInitialized && this.update) {
                    if (this.isTemplate) {
                        this.getTemplateList();
                    } else {
                        this.getPolicyList();
                    }
                }
            },
        },
    },
};
</script>


<style scoped>

.add-condition-container {
    display: inline-block;
    cursor: pointer;
}

.ag-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.and-text {
    color: #B0B0B0;
    margin-left: 1rem;
    margin-top: 0.8rem;
}

.create-event {
    position: relative;
    background: #FFFFFF;
    width: 90%;
    max-height: 90%;
    overflow-y: visible;
    display: flex;
    flex-direction: column;
    max-width: 1300px;
}

.create-event-footer {
    width: 100%;
    padding: 25px;
    background-color: #F8F8F8;
    margin-top: auto;
}

.create-event-header {
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #F8F8F8;
}

.delete-icon {
    font-size: 12px;
    margin-top: 0.5rem;
}

.dropdown-container {
    white-space: nowrap;
}

.eventTypeSelect {
    height: 30px;
    margin-bottom: 8px;
    width: 205px;
}

.icon {
    font-size: 10px;
}
.italic {
    font-style: italic;
}

.label {
    margin-right: 10px;
}

.label,
.form-control {
    display: inline-block;
    vertical-align: middle;
}

.rules {
    padding-left: 2%;
    padding-right: 2%;
    padding-top: 2%;
}</style>